export function Crosshair() {
  return (
    <div className="pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
      <div className="relative h-8 w-8">
        <div className="absolute left-1/2 top-0 h-2 w-0.5 -translate-x-1/2 bg-white/80" />
        <div className="absolute bottom-0 left-1/2 h-2 w-0.5 -translate-x-1/2 bg-white/80" />
        <div className="absolute left-0 top-1/2 h-0.5 w-2 -translate-y-1/2 bg-white/80" />
        <div className="absolute right-0 top-1/2 h-0.5 w-2 -translate-y-1/2 bg-white/80" />
        <div className="absolute left-1/2 top-1/2 h-1 w-1 -translate-x-1/2 -translate-y-1/2 rounded-full bg-white" />
      </div>
    </div>
  );
}
